import React from "react";
import { Workbox } from 'workbox-window';

const ServiceWorkerRegistration = () => {
    // Register the service worker & simple sanity checks
    if (window && window.navigator && ('serviceWorker' in navigator)) {
        const wb = new Workbox('/sw.js');

        wb.addEventListener('installed', event => {
            console.log("Service worker installed")
            if (event.isUpdate) {
                //if (confirm(`New content is available!. Click OK to refresh`)) {
                console.log("Updated the service worker")
                window.location.reload();
                //}
            }
        });

        wb.register();
    }
    return <></>
}

export default React.memo(ServiceWorkerRegistration);